var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"account"},[_c('Main'),_c('Email'),_c('Password')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }